export const formatIDR = (n) =>
  new Intl.NumberFormat("id-ID", { maximumFractionDigits: 0 }).format(Math.round(n || 0));

export const formatDateTime = (iso) =>
  iso
    ? new Date(iso).toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "-";

export const formatDate = (iso) =>
  iso
    ? new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
    : "-";

export const ROLE_LABELS = {
  owner: "Owner",
  branch_manager: "Branch Manager",
  admin_gudang: "Warehouse Admin",
  admin_toko: "Store Admin",
};

export const REF_TYPE_LABELS = {
  purchase: "Purchase",
  transfer: "Transfer",
  sale: "Sale",
  void: "Deletion",
};
